import React, { useState } from 'react';
import { Box, AppBar, Toolbar, Typography, Button, BottomNavigation, BottomNavigationAction, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ConstructionIcon from '@mui/icons-material/Construction';
import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';
import GroupIcon from '@mui/icons-material/Group';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import UsersList from './lists/UsersList';
import RolesList from './lists/RolesList';
import CompaniesList from './lists/CompaniesList';
import ScriptsList from './lists/ScriptsList';
import ScriptStepsList from './lists/ScriptStepsList';
import ConstructionsList from './lists/ConstructionsList';
import UsersInConstructionList from './lists/UsersInConstructionList';
import TasksList from './lists/TasksList';
import FilesList from './lists/FilesList';
import HistoryList from './lists/HistoryList';
import CommentsList from './lists/CommentsList';

const Dashboard = () => {
  const [value, setValue] = useState(0);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleChange = (event, newValue) => {
    if (newValue === tabs.length - 1) {
      setLogoutDialogOpen(true);
    } else {
      setValue(newValue);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleConfirmLogout = () => {
    handleLogout();
    setLogoutDialogOpen(false);
  };

  const handleCancelLogout = () => {
    setLogoutDialogOpen(false);
  };

  const tabs = [
    { label: 'Задачи', component: <TasksList />, icon: <AssignmentIcon /> },
    { label: 'Строительный объект', component: <ConstructionsList />, icon: <ConstructionIcon /> },
    { label: 'Компании', component: <CompaniesList />, icon: <BusinessIcon /> },
    //{ label: 'Пользователи в объекте', component: <UsersInConstructionList /> },
    { label: 'Сотрудники', component: <UsersList />, icon: <PeopleIcon /> },
    //{ label: 'Роли', component: <RolesList />, icon: <GroupIcon /> },
    //{ label: 'Скрипты', component: <ScriptsList /> },
    //{ label: 'Шаги скриптов', component: <ScriptStepsList /> },
    //{ label: 'Файлы', component: <FilesList /> },
    //{ label: 'История', component: <HistoryList /> },
    //{ label: 'Комментарии', component: <CommentsList /> },
    { label: 'Выход', icon: <ExitToAppIcon /> },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Box sx={{ flexGrow: 1, p: 3, pb: '70px' }}>
        {tabs[value] && tabs[value].component}
      </Box>
      <BottomNavigation
        value={value}
        onChange={handleChange}
        showLabels
        sx={{ position: 'fixed', bottom: 0, width: '100%' }}
      >
        {tabs.map((tab, index) => (
          <BottomNavigationAction key={index} label={tab.label} icon={tab.icon} />
        ))}
      </BottomNavigation>
      <Dialog open={logoutDialogOpen} onClose={handleCancelLogout}>
        <DialogTitle>Подтверждение выхода</DialogTitle>
        <DialogContent>
          Вы действительно хотите выйти?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelLogout}>Отмена</Button>
          <Button onClick={handleConfirmLogout} color="primary">Выход</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Dashboard;